import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BookTrial from './Components/BookTrial';
import SuccessPage from './Components/SuccessPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BookTrial />} />
        <Route path="/SuccessPage" element={<SuccessPage />} />
      </Routes>
    </Router>
  );
};

export default App;
